import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const updateTranscribeShotclass = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.UPDATE_TRANSCIBE_SHOTCLASS,
    data
  );
};

export default updateTranscribeShotclass;
